exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar[data-v-15f41af8] {\n  font-weight: bold;\n  font-size: 18px;\n}\n.toolbar .text[data-v-15f41af8] {\n  padding-left: 15px;\n  color: white;\n  text-decoration: none;\n}\n.logo[data-v-15f41af8] {\n  max-width: 40px;\n}", ""]);

// exports
